module.exports = "https://cdn.hellotech.com/client-assets/shp-cart-thumbnail_0248b06d21c49c5439b047057924b756.png";